/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import { AuthConfig } from '@/auth/utils'
import router from '@/router'

import { RepositoryFactory } from '@/http/api/RepositoryFactory'
const UserRepository = RepositoryFactory.get('auth')['userRepository'];

import ability from '@/libs/acl/ability'
import { initialAbility, initialAuthenticatedAbility } from '@/libs/acl/config'

import { generateUserAbilities } from '@/libs/acl/utils'

export default {

    fetchUser ({ commit, dispatch }, params) {
        return new Promise((resolve, reject) => {
          UserRepository.get(params)
            .then((response) => {
                commit('UPDATE_USER_INFO', {
                  id: response.data.pk,
                  info: {
                      username: response.data.username,
                      email: response.data.email,
                      full_name: response.data.full_name,
                      first_name: response.data.first_name,
                      last_name: response.data.last_name
                  }
              })

                const abilities = generateUserAbilities(response.data.permissions)
                ability.update([...initialAuthenticatedAbility, ...abilities])

                resolve(response)
            })
            .catch((error) => reject(error))
        })
      },

    // Login
    login({commit, dispatch}, payload) {
        return new Promise((resolve, reject) => {
            AuthConfig.login(payload)
                .then((response) => {

                    const abilities = generateUserAbilities(response.data.user.permissions)
                    ability.update([...initialAuthenticatedAbility, ...abilities])

                    router.push('/')
                })
                .catch((err) => reject(err))
        })

    },

    // Register
    register({commit, dispatch}, payload) {
        return new Promise((resolve, reject) => {
            AuthConfig.register(payload)
                .then(() => router.push('/login'))
                .catch((err) => reject(err))
        })
    },

    // Log out
    logout({commit, dispatch}, payload) {
        return new Promise((resolve, reject) => {
            AuthConfig.logout(payload)
                .then(() => {
                    ability.update([...initialAbility])
                    router.push('/login')
                })
                .catch((err) => reject(err))
        })
    },

    sendPasswordResetEmail({commit, dispatch}, payload) {
        return new Promise((resolve, reject) => {
            AuthConfig.sendPasswordResetEmail(payload)
                .then(() => router.push('/login'))
                .catch((err) => reject(err))
        })
    },

    resetPassword({commit, dispatch}, payload) {
        return new Promise((resolve, reject) => {
            AuthConfig.resetPassword(payload)
                .then(() => router.push('/login'))
                .catch((err) => reject(err))
        })
    },

}


